/* Circular progress with a glowing, animated stroke. */
export default function ProgressRing({ value = 0, size = 56, stroke = 5, color = 'var(--brand-green)', children }) {
    const r = (size - stroke) / 2;
    const c = 2 * Math.PI * r;
    const pct = Math.max(0, Math.min(100, value));
    return (
        <span className="progress-ring" style={{ width: size, height: size }}>
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
                <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--brand-bg2)" strokeWidth={stroke} />
                <circle
                    className="progress-ring__bar"
                    cx={size / 2}
                    cy={size / 2}
                    r={r}
                    fill="none"
                    stroke={color}
                    strokeWidth={stroke}
                    strokeLinecap="round"
                    strokeDasharray={c}
                    strokeDashoffset={c - (pct / 100) * c}
                    style={{ filter: `drop-shadow(0 0 4px ${color})` }}
                />
            </svg>
            {children && <span className="progress-ring__label">{children}</span>}
        </span>
    );
}
